import { render, staticRenderFns } from "./mainManage.vue?vue&type=template&id=57aef8b2&scoped=true&"
import script from "./mainManage.vue?vue&type=script&lang=js&"
export * from "./mainManage.vue?vue&type=script&lang=js&"
import style0 from "./mainManage.vue?vue&type=style&index=0&id=57aef8b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aef8b2",
  null
  
)

export default component.exports